import Icon from '@mdi/react'

import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'

const EmptyState = ({
    icon,
    title,
    message,
    iconColor,
    children,
}: {
    icon: string
    title: string
    message: string | React.ReactElement
    iconColor: string
    children?: React.ReactNode
}) => {
    return (
        <Flex direction="column" alignItems="center" justifyContent="center" flex="1">
            <Icon path={icon} size="52px" color={iconColor} />
            <Text fontSize="50px" fontWeight="bold" py="16px" lineHeight="80px">
                {title}
            </Text>
            <Text textAlign="center">{message}</Text>
            {children}
        </Flex>
    )
}

export default EmptyState
